import { ButtonIcon } from './ButtonIcon';
import { ButtonRoot } from './ButtonRoot';
import { ButtonText } from './ButtonText';

export const Button = Object.assign(ButtonRoot, {
  Icon: ButtonIcon,
  Text: ButtonText,
});

export default Button;
